import { jwtDecode } from "jwt-decode";
import { useMemo } from "react";
import { useSelector } from "react-redux";

// Backend sets `isreport = !activeRestriction` on login, so `false` means the
// user currently has an active posting restriction.
const usePostRestriction = () => {
  const { user, token } = useSelector((state) => state.authSlice);

  const isreport = useMemo(() => {
    if (typeof user?.isreport === "boolean") return user.isreport;
    if (!token) return undefined;
    try {
      return jwtDecode(token)?.isreport;
    } catch {
      return undefined;
    }
  }, [user?.isreport, token]);

  return { isPostRestricted: isreport === false };
};

export default usePostRestriction;
